const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://quangninhsmartcity-api.cgis.asia/",
        media_url: "https://quangninhsmartcity-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "dttm_quangninh",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/dttm_quangninh/wms/",
  },
  production: {
      api: "https://quangninhsmartcity-api.cgis.asia/",
      media_url: "https://quangninhsmartcity-api.cgis.asia/",
      domainAdminSide: "https://admin.quangninhsmartcity.cgis.asia",
      domainUserSide: "https://quangninhsmartcity.cgis.asia",
      domainName: "quangninhsmartcity.cgis.asia",
      workSpace: "dttm_quangninh",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/dttm_quangninh/wms/",
  },
};

module.exports = apiEnvironment[env];
